{
    "TermsAndConditions_Title": "Termos e Condições",
    "TermsAndConditions_Subtitle": "Os termos e condições de uso do aplicativo são apresentados abaixo. Indique sua aceitação marcando a opção \"Concordo com os termos de serviço\" e clicando no botão \"Aceitar\".",
    "TermsAndConditions_Subtitle_NoAccept": "Nossos termos de serviço padrão são mostrados abaixo.",
    "TermsAndConditions_AcceptText": "Eu concordo com os termos e condições",
    "TermsAndConditions_AcceptButton": "Aceitar",
    "TermsAndConditions_CloseButton": "Fechar",
    "NAME": "TermsAndConditions"
}